/**
 * @fileoverview Agent definition for chapter-rebuilder-v1.
 *
 * Updates chapter metadata (keyEvents, chapterGoals) based on actual chapter content.
 * Conservative agent that only changes things that are clearly and factually different.
 *
 * @category narrative.chapters.operations
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'chapter-rebuilder-v1',
  kind: 'primitive',
  name: 'Chapter Rebuilder',
  description: 'Rebuilds chapter metadata (key events, plot development, character development, progression/tension) from actual chapter content.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.chapters.operations',
    usedBy: [
      'primitives/use-chapter-rebuilder-v1.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'scenes-rebuilder-v1',
      'chapter-planner-v2',
      'key-events-expander-v2',
    ],
  },
};
